export const isAccountOperLoading = ({ account }) => {
  if (account && account?.accountOper) {
    return account.accountOper.status === 'loading'
  }

  return false
}
